import { render, staticRenderFns } from "./customerApproval.vue?vue&type=template&id=0256936c&scoped=true"
import script from "./customerApproval.vue?vue&type=script&lang=js"
export * from "./customerApproval.vue?vue&type=script&lang=js"
import style0 from "./customerApproval.vue?vue&type=style&index=0&id=0256936c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0256936c",
  null
  
)

export default component.exports